import React, { useEffect } from 'react';
import { Slider, Tooltip, withStyles } from '@material-ui/core';
import { Inputs } from '../../Controls';
import { Remove } from '@material-ui/icons';

const PrettoSlider = withStyles({
  root: {
    color: '#52af77',
    height: 8,
  },
  thumb: {
    height: 24,
    width: 24,
    backgroundColor: '#fff',
    border: '2px solid currentColor',
    marginTop: -8,
    marginLeft: -12,
    '&:focus, &:hover, &$active': {
      boxShadow: 'inherit',
    },
  },
  active: {},
  valueLabel: {
    left: 'calc(-50% + 4px)',
  },
  track: {
    height: 8,
    borderRadius: 4,
  },
  rail: {
    height: 8,
    borderRadius: 4,
  },
})(Slider);

function ValueLabelComponent(props) {
  const { children, open, value } = props;

  return (
    <Tooltip open={open} enterTouchDelay={0} placement='top' title={value}>
      {children}
    </Tooltip>
  );
}

const SliderWithInputs = ({
  getAriaValueText,
  defaultValue,
  value,
  max,
  min,
  onChange,
  startAdornment,
}) => {
  return (
    <div className='px-2 py-1'>
      <PrettoSlider
        valueLabelDisplay='auto'
        defaultValue={defaultValue}
        value={value}
        max={max}
        min={min}
        step={min}
        ValueLabelComponent={ValueLabelComponent}
        onChange={(_e, newValue) => {
          onChange(newValue);
        }}
        valueLabelFormat={getAriaValueText}
      />
      <div className='d-flex fj-between gap-1 fa-center'>
        <Inputs
          startAdornment={startAdornment}
          type='number'
          defaultValue={value[0]}
          labelValue={'min'}
          max={max}
          min={min}
          step={min}
          onInputChanged={(e) => {
            let newValue = e.target.valueAsNumber;
            if (newValue < min || newValue > max || newValue > value[1]) {
              return;
            }
            onChange([e.target.valueAsNumber, value[1]]);
          }}
          onInputBlur={(e) => {
            if (e.target.valueAsNumber < min) {
              e.target.value = min;
            } else if (e.target.valueAsNumber > max) {
              e.target.value = max;
            } else if (e.target.valueAsNumber >= value[1]) {
              e.target.value = value[0];
            }
          }}
        />
        <Remove fontSize='large' />
        <Inputs
          startAdornment={startAdornment}
          type='number'
          defaultValue={value[1]}
          max={max}
          min={min}
          labelValue={'max'}
          onInputChanged={(e) => {
            if (
              e.target.valueAsNumber < min ||
              e.target.valueAsNumber > max ||
              e.target.valueAsNumber < value[0]
            ) {
              return;
            }
            onChange([value[0], e.target.valueAsNumber]);
          }}
          onInputBlur={(e) => {
            if (e.target.valueAsNumber < min) {
              e.target.value = min;
            } else if (e.target.valueAsNumber > max) {
              e.target.value = max;
            } else if (e.target.valueAsNumber <= value[0]) {
              e.target.value = value[1];
            }
          }}
        />
      </div>
    </div>
  );
};

export default SliderWithInputs;
